module.exports = __webpack_public_path__ + "static/media/subhero2.4717d2ac.png";